import '.b{display:flex;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.a1{height:80px;}.ssr-plugin'
import '.g{width:100%;}.ssr-plugin'
import '.a2{padding:0 30px;}.ssr-plugin'
import '.h{background:#131313;}.ssr-plugin'
import '.a3{box-shadow:0 2px 4px rgba(0,0,0,0.1);}.ssr-plugin'
import '.t{box-sizing:border-box;}.ssr-plugin'
import '.a4{border-bottom:1px solid grey;}.ssr-plugin'
import '.a5{gap:1rem;}.ssr-plugin'
import '.a6{flex-shrink:0;}.ssr-plugin'
import { styled } from 'inlines'
import { Logo } from './Logo.js'
import { Button } from './Button.js'
import { useLocation } from 'wouter'

export const TopBar = () => {
  const [, setLocation] = useLocation()

  return (
    <styled.div className="b a0 c a1 g a2 h a3 t a4"
      style={{
        '@media (max-width: 480px)': {
          padding: '0 15px',
        },}}
    >
      <Logo />
      <styled.div className="b a5 a6 c"
        style={{
          '@media (max-width: 480px)': {
            gap: '0.5rem',
          },
        }}
      >
        <Button style={{ marginTop: 0 }} onClick={() => setLocation('/vote')}>
          Vote now
        </Button>
        <Button
          style={{ marginTop: 0 }}
          onClick={() => setLocation('/contestant-cards')}
        >
          Contestants
        </Button>
      </styled.div>
    </styled.div>
  )
}
